const enum IntervalType {
  IsoYear = 6,
  Month = 2,
  Week = 5,
  Day = 4,
  Hour = 9,
}

export default IntervalType;
